import { css } from '@emotion/react';

import { classes as buttonBaseClasses } from '@core/ButtonBase/getButtonBaseCss';
import { typography } from '@core/Typography2';
import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('actionOverflowMenu', [
  'menu',
  'menuItem',
  'groupLabel',
  'groupDivider',
]);

const getActionOverflowMenuCss = css`
  &.${classes.menu} {
    background-color: var(--cds-color-neutral-background-primary);
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-25);
    margin: 0;
    padding: var(--cds-spacing-50);
    list-style: none;
    overflow-y: auto;

    li {
      display: flex;
    }
  }

  .${classes.menuItem} {
    ${typography.bodyPrimary};
    color: var(--cds-color-neutral-primary);
    display: flex;
    justify-content: flex-start;
    gap: var(--cds-spacing-150);
    padding: var(--cds-spacing-100);
    border-radius: var(--cds-border-radius-100);
    width: 100%;
    cursor: pointer;

    &.${buttonBaseClasses.focusVisible} {
      color: var(--cds-color-interactive-secondary-hover);
      background-color: var(
        --cds-color-interactive-background-secondary-hover-weak
      );
    }

    &:hover,
    &:active {
      color: var(--cds-color-interactive-secondary-hover);
      background-color: var(
        --cds-color-interactive-background-secondary-hover-weak
      );
    }

    &[aria-disabled='true'] {
      color: var(--cds-color-neutral-disabled-strong);
      background-color: var(--cds-color-neutral-background-primary);
    }

    &[aria-current='page'] {
      background-color: var(
        --cds-color-interactive-background-secondary-hover-weak
      );
      ${typography.subtitleMedium};
    }
  }

  .${classes.groupDivider} {
    padding: var(--cds-spacing-100) 0;
    flex-direction: column;

    &:first-of-type {
      display: none;
    }
  }

  .${classes.groupLabel} {
    ${typography.subtitleMedium};
    color: var(--cds-color-neutral-primary);
    padding: var(--cds-spacing-100);
    text-align: left;
  }
`;

export default getActionOverflowMenuCss;
